import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { Card } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';

/** Экран для авто-приостановленного стажёра: сообщение + запрос админу на возобновление. */
export default function SuspendedScreen() {
  const [sent, setSent] = useState(false);
  const req = useMutation({
    mutationFn: () => api.post<{ requested: boolean }>('/api/me/reactivate', {}),
    onSuccess: () => setSent(true),
  });

  return (
    <div className="min-h-full flex items-center justify-center p-4">
      <Card className="max-w-md w-full space-y-4 text-center">
        <div className="text-4xl">⏸</div>
        <div className="text-lg font-semibold">Доступ приостановлен</div>
        <p className="text-sm text-tg-hint">
          Вы не заходили продолжительное время, ваш доступ приостановлен.
        </p>
        {sent ? (
          <div className="text-sm text-green-600">
            ✅ Запрос отправлен администратору. Ожидайте — вам вернут доступ.
          </div>
        ) : (
          <>
            <Button className="w-full" disabled={req.isPending} onClick={() => req.mutate()}>
              {req.isPending ? 'Отправляем…' : 'Отправить запрос админу на возобновление'}
            </Button>
            {req.isError && (
              <div className="text-xs text-red-500">
                Не удалось отправить. Попробуйте ещё раз.
              </div>
            )}
          </>
        )}
      </Card>
    </div>
  );
}
